

































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import IUser from '@/models/IUser'
import ISplit from '@/models/ISplit'

@Component
export default class TransactionSplit extends Vue {
  @Getter
  public user!: IUser | null
  @Prop({ type: Object, required: true })
  public split!: ISplit
  public checked: boolean = false

  public plus(): void {
    this.split.weight++
  }

  public minus(): void {
    this.split.weight = Math.max(this.split.weight - 1, 0)
  }

  @Watch('checked')
  public onCheckedChange(check: boolean): void {
    if (check && this.split.weight === 0) {
      this.split.weight = 1
    } else if (!check && this.split.weight > 0) {
      this.split.weight = 0
    }
  }

  @Watch('split.weight', { immediate: true })
  public onWeightChange(weight: number): void {
    if (weight === 0 && this.checked) {
      this.checked = false
    } else if (weight > 0 && !this.checked) {
      this.checked = true
    }
  }
}
